/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_LocaleInputs */

const cs_settings_office_locale = /** @type {(inputs: Settings_Office_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jazyk`)
};

const en_settings_office_locale = /** @type {(inputs: Settings_Office_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locale`)
};

/**
* | output |
* | --- |
* | "Locale" |
*
* @param {Settings_Office_LocaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_locale = /** @type {((inputs?: Settings_Office_LocaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_LocaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_locale(inputs)
	return cs_settings_office_locale(inputs)
});